import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import topBg from '../../Common/Assets/Images/home1-top-bg.png';
import BottumBg from '../../Common/Assets/Images/home1-bottum-bg.png';
import '../../Common/CSS/Style.css';

function MatchResults() {
  const location = useLocation();
  const navigate = useNavigate();
  const { matchCount, count, success, error } = location.state || {};

  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (count > 0) {
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 4000);
      return () => clearTimeout(timer);
    }

    if (matchCount === undefined) {
      navigate('/mothers');
    }
  }, [count, matchCount, navigate]);

  const handleDownloadAndroid = () => {
    window.open('https://play.google.com/store/apps/details?id=com.matchersapp.app', '_blank');
  };

  const handleDownloadIOS = () => {
    window.open('https://apps.apple.com/app/id1640479105', '_blank');
  };

  const goBack = () => {
    navigate('/mothers');
  };

  const ConfettiPiece = ({ delay, duration, color }) => (
    <div
      style={{
        position: 'absolute',
        width: '10px',
        height: '10px',
        backgroundColor: color,
        animation: `confetti-fall ${duration}s linear ${delay}s infinite`,
        left: `${Math.random() * 100}vw`,
        top: '-20px',
        borderRadius: Math.random() > 0.5 ? '50%' : '0%',
        transform: `rotate(${Math.random() * 360}deg)`,
      }}
    />
  );

  const createConfetti = () => {
    const confettiColors = [
      '#ee2c46',
      '#ff6b6b',
      '#4ecdc4',
      '#45b7d1',
      '#96ceb4',
      '#ffeaa7',
      '#dda0dd',
    ];
    return Array.from({ length: 50 }).map((_, i) => (
      <ConfettiPiece
        key={i}
        delay={Math.random() * 4}
        duration={2 + Math.random() * 3}
        color={confettiColors[i % confettiColors.length]}
      />
    ));
  };

  const renderContent = () => {
    if (success && count > 0) {
      return (
        <>
          <div className="results-icon">🎉</div>
          <h1 className="results-title">כדאי להירשם!</h1>
          <div className="match-count-display">
            <p>מספר ההתאמות הפוטנציאליות:</p>
            <div className="count">{matchCount}</div>
          </div>
          <p className="results-message">{count === 1 ? 'התאמה מושלמת נמצאה! 💖' : ''}</p>
        </>
      );
    }

    if (success === false) {
      return (
        <>
          <div className="results-icon">❌</div>
          <h1 className="results-title">אירעה שגיאה</h1>
          <p className="results-message">
            {error || 'לא ניתן היה לעבד את הבקשה. נסו שוב מאוחר יותר.'}
          </p>
        </>
      );
    }

    return (
      <>
        <div className="results-icon">😔</div>
        <h1 className="results-title">לא נמצאו התאמות כרגע</h1>
        <p className="results-message">
          אל דאגה, המאגר שלנו מתעדכן כל הזמן. הורידי את האפליקציה וקבלי עדכון כשתמצא התאמה חדשה!
        </p>
      </>
    );
  };

  return (
    <>
      <style>{`
        .match-results-page {
          font-family: 'Heebo', sans-serif;
          direction: rtl;
          text-align: center;
        }
        .results-container {
          padding: 2rem 1rem;
          max-width: 650px;
          margin: 0 auto;
        }
        .results-header {
          margin-bottom: 2rem;
        }
        .results-header .logo {
          max-width: 150px;
        }
        .results-card {
          background-color: #ffffff;
          padding: 3rem 2rem;
          border-radius: 16px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          margin-top: 2rem;
        }
        .results-icon {
          font-size: 4rem;
          line-height: 1;
          margin-bottom: 1.5rem;
          animation: ${showConfetti ? 'bounce 1.5s ease-in-out' : 'none'};
        }
        .results-title {
          font-size: 2.25rem;
          font-weight: 700;
          color: #2c3e50;
          line-height: 1.3;
          margin-bottom: 1rem;
        }
        .results-message {
          font-size: 1.15rem;
          color: #7f8c8d;
          margin: 0 auto 2.5rem auto;
          max-width: 450px;
        }
        .match-count-display {
          background-color: #ee2c46;
          border-radius: 12px;
          padding: 1.5rem;
          margin: 2rem auto 2.5rem auto;
          color: white;
          max-width: 300px;
        }
        .match-count-display p {
          font-size: 1rem;
          margin-bottom: 0.5rem;
          font-weight: 400;
          opacity: 0.9;
        }
        .match-count-display .count {
          font-size: 3.5rem;
          font-weight: bold;
        }
        .download-section {
          margin-top: 3rem;
          padding: 2.5rem;
          background-color: #f8f9fa;
          border-radius: 16px;
        }
        .download-section .icon {
          max-width: 60px;
          margin-bottom: 1.5rem;
        }
        .download-section h3 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #ee2c46;
          margin-bottom: 1rem;
        }
        .download-section p {
          font-size: 1rem;
          color: #7f8c8d;
          margin-bottom: 2rem;
        }
        .btn-group {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }
        .styled-btn {
          padding: 14px 28px;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: bold;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          text-decoration: none;
        }
        .primary-btn {
          background: linear-gradient(45deg, #f06, #ee2c46);
          color: #fff;
          box-shadow: 0 5px 15px rgba(238, 44, 70, 0.3);
        }
        .primary-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(238, 44, 70, 0.4);
        }
        .secondary-btn {
          background-color: transparent;
          color: #34495e;
          font-weight: 600;
          margin-top: 2.5rem;
        }
        .secondary-btn:hover {
          color: #ee2c46;
        }
        .gold-text {
          color: #DAA520 !important;
          font-size: 1.3rem;
          font-weight: 600;
          margin: 0;
          padding: 0;
          line-height: 1;
        }
        @keyframes confetti-fall {
          from { transform: translateY(-20px) rotate(0deg); opacity: 1; }
          to { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
        @keyframes bounce {
          0%, 20%, 60%, 100% { transform: translateY(0); }
          40% { transform: translateY(-20px); }
          80% { transform: translateY(-10px); }
        }
      `}</style>

      {showConfetti && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: 'none',
            zIndex: 1000,
          }}
        >
          {createConfetti()}
        </div>
      )}

      <div className="main-home match-results-page">
        <div className="universal-background-top">
          <img className="universal-background-top-img" src={topBg} alt="background" />
        </div>

        <div className="results-container">
          <header className="results-header">
            <img className="img-fluid logo" alt="logo" src="./images/logo.png" />
          </header>

          <main>
            <div className="results-card">
              {renderContent()}

              <div className="download-section">
                <h3>הורידי את האפליקציה</h3>
                <p
                  className="gold-text"
                  style={{ margin: '0 0 0.5rem 0', padding: 0, lineHeight: 1 }}
                >
                  וכנסי לרשימת הזהב של{' '}
                  <span style={{ fontSize: '1.5rem', fontWeight: '800' }}>אמהות לא אוגרות</span>
                </p>
                <div className="btn-group">
                  <button onClick={handleDownloadAndroid} className="styled-btn primary-btn">
                    <span style={{ fontSize: '1.2rem' }}>📱</span>
                    הורדה ל-Android
                  </button>
                  <button onClick={handleDownloadIOS} className="styled-btn primary-btn">
                    <span style={{ fontSize: '1.2rem' }}>🍎</span>
                    הורדה ל-iOS
                  </button>
                </div>
              </div>

              <button onClick={goBack} className="styled-btn secondary-btn">
                חזרה לחיפוש חדש
              </button>
            </div>
          </main>
        </div>

        <div className="universal-background-bottom select-detail-universal-bac-bottum">
          <img className="universal-background-bottom-img" src={BottumBg} alt="background" />
        </div>
      </div>
    </>
  );
}

export default MatchResults;
